import { compose, withProps } from 'recompose'
import { connect } from 'react-redux'

import makeMapStateToProps from './makeMapStateToProps'
import mapPropsToListItems from './mapPropsToListItems'

const enhance = compose(
  connect(makeMapStateToProps),
  withProps(props => {
    const items = mapPropsToListItems(props)
    const noNotes = props.allChannelNotes.length === 0

    return {
      items,
      structureIsEmpty: noNotes,
      noNotes,
    }
  })
)

export default enhance
